
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 19","width":"24","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 4l1.42 4.05 4.29.1-3.42 2.6 1.24 4.1L10 12.41l-3.53 2.44 1.24-4.1-3.42-2.6 4.3-.1L10 4z","fill":"#1DCA6E"}})])
          )
        }
      }
    